import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { booleanArray2jdug9b51huk7 as booleanArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { get_EMPTY_SERIALIZER_ARRAY2gyuhuf2kalz as get_EMPTY_SERIALIZER_ARRAY } from './PluginHelperInterfaces.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { compactArray1b2nl9rkq8nuz as compactArray } from './Platform.common.mjs';
import { CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance } from '../descriptors/SerialKinds.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  getChecked1o70dkx10jwym as getChecked,
  getChecked3avs2psuwt1xd as getChecked_0,
} from './Platform.mjs';
import {
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  get_elementDescriptors13xxljc24xo44 as get_elementDescriptors,
} from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { until1jbpn0z3f8lbg as until } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_childSerializers__7vnyfa($this) {
  var tmp0 = $this.g1y_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('childSerializers', 1, tmp, PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca(), null);
  return tmp0.n3();
}
function _get__hashCode__tgwhef($this) {
  var tmp0 = $this.i1y_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz(), null);
  return tmp0.n3();
}
function buildIndices($this) {
  var indices = HashMap().s8();
  var inductionVariable = 0;
  var last = $this.b1y_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = $this.b1y_1[i];
      indices.b5(key, i);
    }
     while (inductionVariable <= last);
  return indices;
}
function PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca() {
  return constructCallableReference((p0) => _get_childSerializers__7vnyfa(p0), 1, 0, 13);
}
function PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka() {
  return constructCallableReference((p0) => p0.f1z(), 1, 0, 14);
}
function PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz() {
  return constructCallableReference((p0) => _get__hashCode__tgwhef(p0), 1, 0, 15);
}
var PluginGeneratedSerialDescriptorClass;
function PluginGeneratedSerialDescriptor() {
  if (PluginGeneratedSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, generatedSerializer, elementsCount) {
        generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
        this.x1x_1 = serialName;
        this.y1x_1 = generatedSerializer;
        this.z1x_1 = elementsCount;
        this.a1y_1 = -1;
        var tmp = this;
        var tmp_0 = 0;
        var tmp_1 = this.z1x_1;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_2 = Array(tmp_1);
        while (tmp_0 < tmp_1) {
          tmp_2[tmp_0] = '[UNINITIALIZED]';
          tmp_0 = tmp_0 + 1 | 0;
        }
        tmp.b1y_1 = tmp_2;
        var tmp_3 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.z1x_1;
        tmp_3.c1y_1 = Array(size);
        this.d1y_1 = null;
        this.e1y_1 = booleanArray(this.z1x_1);
        this.f1y_1 = emptyMap();
        var tmp_4 = this;
        var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_4.g1y_1 = lazy(tmp_5, () => {
          var tmp0_safe_receiver = this.y1x_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w1z();
          return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
        });
        var tmp_6 = this;
        var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_6.h1y_1 = lazy(tmp_7, () => {
          var tmp0_safe_receiver = this.y1x_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1z();
          var tmp;
          if (tmp1_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList().i2(tmp1_safe_receiver.length);
            var inductionVariable = 0;
            var last = tmp1_safe_receiver.length;
            while (inductionVariable < last) {
              var item = tmp1_safe_receiver[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              var tmp$ret$5 = item.b1n();
              destination.j2(tmp$ret$5);
            }
            tmp = destination;
          }
          return compactArray(tmp);
        });
        var tmp_8 = this;
        var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_8.i1y_1 = lazy(tmp_9, () => hashCodeImpl(this, this.f1z()));
      }
      e1o() {
        return this.x1x_1;
      }
      z1p() {
        return this.z1x_1;
      }
      x1p() {
        return CLASS_getInstance();
      }
      a1q() {
        var tmp0_elvis_lhs = this.d1y_1;
        return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      }
      b1r() {
        return this.f1y_1.w4();
      }
      f1z() {
        var tmp0 = this.h1y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('typeParameterDescriptors', 1, tmp, PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka(), null);
        return tmp0.n3();
      }
      g1z(name, isOptional) {
        this.a1y_1 = this.a1y_1 + 1 | 0;
        this.b1y_1[this.a1y_1] = name;
        this.e1y_1[this.a1y_1] = isOptional;
        this.c1y_1[this.a1y_1] = null;
        if (this.a1y_1 === (this.z1x_1 - 1 | 0)) {
          this.f1y_1 = buildIndices(this);
        }
      }
      k1y(name, isOptional, $super) {
        isOptional = isOptional === VOID ? false : isOptional;
        var tmp;
        if ($super === VOID) {
          this.g1z(name, isOptional);
          tmp = Unit_instance;
        } else {
          tmp = $super.g1z.call(this, name, isOptional);
        }
        return tmp;
      }
      l1y(annotation) {
        // Inline function 'kotlin.let' call
        var it = this.c1y_1[this.a1y_1];
        var tmp;
        if (it == null) {
          var result = ArrayList().i2(1);
          this.c1y_1[this.a1y_1] = result;
          tmp = result;
        } else {
          tmp = it;
        }
        var list = tmp;
        list.j2(annotation);
      }
      j1y(a) {
        if (this.d1y_1 == null) {
          this.d1y_1 = ArrayList().i2(1);
        }
        ensureNotNull(this.d1y_1).j2(a);
      }
      e1q(index) {
        return getChecked(_get_childSerializers__7vnyfa(this), index).b1n();
      }
      f1q(index) {
        return getChecked_0(this.e1y_1, index);
      }
      d1q(index) {
        var tmp0_elvis_lhs = getChecked(this.c1y_1, index);
        return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      }
      b1q(index) {
        return getChecked(this.b1y_1, index);
      }
      c1q(name) {
        var tmp0_elvis_lhs = this.f1y_1.v4(name);
        return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.serialization.internal.equalsImpl' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_5;
          }
          if (!(other instanceof PluginGeneratedSerialDescriptor())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.e1o() === other.e1o())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!contentEquals(this.f1z(), other.f1z())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.z1p() === other.z1p())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          var inductionVariable = 0;
          var last = this.z1p();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (!(this.e1q(index).e1o() === other.e1q(index).e1o())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
              if (!equals(this.e1q(index).x1p(), other.e1q(index).x1p())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
            }
             while (inductionVariable < last);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      hashCode() {
        return _get__hashCode__tgwhef(this);
      }
      toString() {
        return toStringImpl(this);
      }
    }
    protoOf($).q1p = get_isNullable;
    protoOf($).y1p = get_isInline;
    initMetadataForClass($, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    PluginGeneratedSerialDescriptorClass = $;
  }
  return PluginGeneratedSerialDescriptorClass;
}
function toStringImpl(_this__u8e3s4) {
  var tmp = until(0, _this__u8e3s4.z1p());
  var tmp_0 = _this__u8e3s4.e1o() + '(';
  return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, (i) => _this__u8e3s4.b1q(i) + ': ' + _this__u8e3s4.e1q(i).e1o());
}
function hashCodeImpl(_this__u8e3s4, typeParams) {
  var result = getStringHashCode(_this__u8e3s4.e1o());
  result = imul(31, result) + contentHashCode(typeParams) | 0;
  var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var _iterator__ex2g4s = elementDescriptors.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = element.e1o();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var namesHash = accumulator;
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator_0 = 1;
  var _iterator__ex2g4s_0 = elementDescriptors.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var hash_0 = accumulator_0;
    var tmp_0 = imul(31, hash_0);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = element_0.x1p();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  }
  var kindHash = accumulator_0;
  result = imul(31, result) + namesHash | 0;
  result = imul(31, result) + kindHash | 0;
  return result;
}
//region block: exports
export {
  PluginGeneratedSerialDescriptor as PluginGeneratedSerialDescriptorqdzeg5asqhfg,
  hashCodeImpl as hashCodeImplfv8qiy3re24s,
  toStringImpl as toStringImpl1y3u8fza7vdq,
};
//endregion

//# sourceMappingURL=PluginGeneratedSerialDescriptor.mjs.map
